import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useChecklistApi() {
  const callApi = useApiCall();

  const getChecklistTypes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_TYPES, data, onSuccess, onError);
  };
  const getChecklistCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_CODE, data, onSuccess, onError);
  };
  const getChecklists = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_CHECKLISTS, data, onSuccess, onError);
  };
  const getChecklistByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_BY_ID, data, onSuccess, onError);
  };

  const saveChecklist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST, data, onSuccess, onError);
  };

  const deleteChecklist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.DELETE_CHECKLIST, data, onSuccess, onError);
  };
  
  const getChecklistInputTypes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_INPUT_TYPES, data, onSuccess, onError);
  };
  
  const saveChecklistTask = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST_TASK, data, onSuccess, onError);
  };
  

  const saveCheckListTasksAssetMapping = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST_TASKS_ASSET_MAPPING, data, onSuccess, onError);
  };
  const getAssetsByChecklist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.GET_ASSETS_BY_CHECKLIST, data, onSuccess, onError);
  };
  const duplicateChecklist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHECKLIST.DUPLICATE_CHECKLIST, data, onSuccess, onError);
  };
    

  return {
    getChecklistTypes,
    getChecklistCode,
    getChecklists,
    getChecklistByID,
    saveChecklist,
    deleteChecklist,
    getChecklistInputTypes,
    saveChecklistTask,
    saveCheckListTasksAssetMapping,
    getAssetsByChecklist,
    duplicateChecklist
  };
}
